import React from 'react';
import styled from 'styled-components/macro';
import { deliveryChooser } from '../../../../containers/commerce/withDeliveryInfo';

const OverlayWrap = styled(({ children, ...props }) => <div {...props}>{children}</div>)`
  margin-bottom: 10px;
`;

const Overlay = ({
  className, component: Component, deliveryOptionComponent, ...restProps
}) => (
  <OverlayWrap className={className}>
    <Component hideError component={deliveryOptionComponent} {...restProps} />
  </OverlayWrap>
);

const StyledOverlay = styled(Overlay)`
  position: relative;
  ${({
    chosen,
    error,
    heightWhenHidden,
    theme,
  }) => {
    if (!chosen && error) {
      return `
        display: none;
      `;
    }
    if (!chosen) {
      return `
        height: ${heightWhenHidden};
        overflow: hidden;
        border: 3px solid ${theme.colors.colorGreyLightAlt};
      `;
    }
    if (chosen) {
      return `
        border: 3px solid ${theme.colors.colorGreenHighlight};
      `;
    }
    return `
      border: 3px solid ${theme.colors.colorGreyLightAlt};
    `;
  }}
`;

export default deliveryType => component => deliveryChooser(
  deliveryType,
)(props => (
  <StyledOverlay {...props} component={component} />
));
